export const copyLinkViaBrowserAPI = async (link: string) =>
  new Promise((resolve, reject) =>
    setTimeout(async () => {
      try {
        await navigator.clipboard.writeText(link);
        resolve(undefined);
      } catch (e) {
        reject(e);
      }
    }, 0),
  );
